const defaultState = () => ({
  incidentFields: [],
  incident: null,
  transmissionHistory: null,
  requestCode: 200,
  emtListCache: {}, // Cache for EMT lists by clientId
});

export default defaultState;
